import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { Show, TabbedShowLayout, TabbedShowLayoutTabs, useRecordContext } from "react-admin";
import { useSelector } from "react-redux";

import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { OutDocWarningsDialog } from "../../../components/fields/DocumentsField/components/OutDocWarningsDialog";
import { OrderStatus, OrderStatusExcludeFunctionality } from "../../../entities";
import { OrderService } from "../../../entities";
import {
	AppManagerRoles,
	OSFCUserRoles,
	TransporterRoles,
	UserRole,
} from "../../../entities/UserRole";
import { isInArray } from "../../../utils/general";
import DeviationsTab from "./DeviationsTab";
import { EditTab } from "./EditTab";
// import { isExternalNotApproved } from 'utils/checker/entity';
import { PalletsTab } from "./PalletsAndBoxes/PalletsTab";
import { PickingListTab } from "./PickingList/PickingListTab";
import {
	ChatTab,
	DocumentsTab,
	GeneralTab,
	OrderHistoryTab,
	OrderPrcelistHistoryTab,
	OutDocumentsTab,
	PlugTab,
} from "./Tabs";

export const tabbedShowLayoutPadding = 8;
// export const OrderShowTabsWrapper = ({permissions, hasShow, children, ...props}) => {
// 	const isOSFCManager = React.useMemo(() => {
// 		if (permissions) {
// 			return (
// 				permissions.role === UserRole.osfc_employee
// 				|| permissions.role === UserRole.osfc_manager
// 			);
// 		}
// 		return false;
// 	}, [permissions]);
// 	if (!permissions) return null;

// 	return (
// 		<Show actions={<ActionsWithBackButton hasEdit={!permissions['company_is_blocked']}/>} {...props}>
// 			<TabbedShowLayout style={{paddingBottom: tabbedShowLayoutPadding}}>
// 				{React.Children.map(children, (tab) => {
// 					return React.cloneElement(tab, {isOSFCManager: isOSFCManager, permissions: permissions});
// 				})}
// 			</TabbedShowLayout>
// 		</Show>
// 	);
// };

// export const OrderShow = (props) => {
// 	if (!props.permissions) return null;

// 	const isOSFCManager = props.permissions && props.permissions.role === UserRole.osfc_manager;

// 	return (
// 		<OrderShowTabsWrapper {...props}>
// 			<GeneralTab/>
// 			{isOSFCManager ? <OrderHistoryTab /> : <PlugTab/>}
// 			{isOSFCManager ? <OrderPrcelistHistoryTab/> : <PlugTab/>}
// 			<DocumentsTab/>
// 			<ChatTab/>
// 		</OrderShowTabsWrapper>
// 	);
// }
const useTabbedStyles = makeStyles((theme) => ({
	tabsBar: (props) => ({
		maxWidth: `calc(100vw - ${props.offset}px)`,

		[theme.breakpoints.down("xs")]: {
			maxWidth: `calc(100vw - 64px)`,
		},

		"& .MuiTabs-scroller": {
			overflowX: "auto !important",
			WebkitOverflowScrolling: "touch",
		},
		"& .MuiTabs-flexContainer": {
			flexWrap: "nowrap",
			maxWidth: `calc(100vw - ${props.offset}px)`,
		},

		"& .MuiTab-root": {
			minWidth: "auto !important",
			paddingLeft: 12,
			paddingRight: 12,
		},
	}),
}));
export const OrderShowTabsWrapper = ({ permissions, ..._props }) => {
	const [outDocWarnings, setOutDocWarnings] = useState([]);
	if (!permissions) return null;
	const props = { ..._props };

	const isDraft = window.location.href.indexOf("draft-orders") !== -1;
	if (isDraft) {
		props.resource = "orders";
		props.title = "resources.draft-orders.name";
	}

	return (
		<>
			<Show
				actions={
					<ActionsWithBackButton
						goBackLabel="ra.action.dashboard"
						hasEdit={false}
						style={{ paddingTop: 0 }}
					/>
				}
				{...props}
			>
				<OrderShow permissions={permissions} onOutDocWarnings={setOutDocWarnings} />
			</Show>
			<OutDocWarningsDialog warnings={outDocWarnings} onClose={() => setOutDocWarnings([])} />
		</>
	);
};
const OrderShow = ({ onOutDocWarnings, ...props }) => {
	const record = useRecordContext();

	let isOrderHistoryTab = false,
		isOrderPrcelistHistoryTab = false,
		isCustomerAsTrans = false,
		isOutDocumentsTab = true,
		isChatTab = true,
		isDeviationsTab = true,
		isPalletsTab = true,
		isPickingListTab = true;

	switch (props.permissions.role) {
		case UserRole.osfc_manager:
			isOrderHistoryTab = true;
			isOrderPrcelistHistoryTab = true;
			break;
		case UserRole.app_manager:
			isOrderHistoryTab = true;
			isOrderPrcelistHistoryTab = true;
			break;
		case UserRole.admin:
			isOrderHistoryTab = true;
			isOrderPrcelistHistoryTab = true;
			break;
		case UserRole.customer_manager:
			isOrderHistoryTab = true;
			break;
		case UserRole.customer_and_transporter_manager:
			isOrderHistoryTab = record["company_id"] === props.permissions["company_id"];
			isCustomerAsTrans = !isOrderHistoryTab;
			break;
		case UserRole.customer_and_transporter_employee:
			isCustomerAsTrans = record["company_id"] !== props.permissions["company_id"];
			break;
		case UserRole.customer_and_transporter_driver:
			isCustomerAsTrans = true;
			break;
		default:
			break;
	}

	if (isInArray(OrderStatusExcludeFunctionality, record.status)) {
		isOrderPrcelistHistoryTab = false;
		isDeviationsTab = false;
		isPalletsTab = false;
		isPickingListTab = false;
		isOutDocumentsTab = false;
	}
	// if (isExternalNotApproved(record.state)) {
	// 	isChatTab = false;
	// }

	// TODO: check if need to pass isOSFCManager={isOSFCManager} permissions={props.permissions} to each tab
	const isPlukkOrder = record.service == OrderService.intoPlukkStorage;
	const isPlukkOrColdStorageOrder = isPlukkOrder || record.service == OrderService.coldStorage;
	const isCrossDockOrder = record.service == OrderService.crossDock;
	const isOSFCManager = props.permissions && isInArray(AppManagerRoles, props.permissions.role);
	const isOSFCUser = props.permissions && OSFCUserRoles.has(props.permissions.role);
	const isSidebarOpen = useSelector((state) => state.admin.ui.sidebarOpen);
	const isPickingListVisible = isPlukkOrder && props?.record?.etd_date;
	const rightSideOffset = isSidebarOpen ? 270 : 64; // for some reason when sidebar is open it makes text go out the screen, so we need to add offset to approximately sidebar width
	const classes = useTabbedStyles({ offset: rightSideOffset });

	const isDeviationUser = props.permissions && !isInArray(TransporterRoles, props.permissions.role);

	return (
		<TabbedShowLayout
			style={{ paddingBottom: tabbedShowLayoutPadding, width: "100%" }}
			{...props}
			tabs={
				<TabbedShowLayoutTabs
					variant="scrollable"
					scrollButtons="auto"
					className={classes.tabsBar}
				/>
			}
		>
			<EditTab permissions={props.permissions} label="tab.edit.name" />
			{isPickingListVisible && isPickingListTab && (
				<PickingListTab
					record={record}
					permissions={props.permissions}
					label="tab.picking_list.name"
				/>
			)}
			{(isPlukkOrColdStorageOrder || isCrossDockOrder) && isPalletsTab && (
				<PalletsTab
					isOSFCManager={isOSFCManager}
					isCustomerAsTrans={isCustomerAsTrans}
					permissions={props.permissions}
					record={props.record}
					label="tab.pallets.name"
					path="pallets"
				/>
			)}
			<DocumentsTab
				isOSFCManager={isOSFCManager}
				isCustomerAsTrans={isCustomerAsTrans}
				permissions={props.permissions}
				label="tab.documents.name"
				path="documents"
			/>
			{isOSFCUser && isOutDocumentsTab ? (
				<OutDocumentsTab
					isOSFCManager={isOSFCManager}
					isCustomerAsTrans={isCustomerAsTrans}
					permissions={props.permissions}
					label="tab.out-documents.name"
					path="internal-documents"
					onOutDocWarnings={onOutDocWarnings}
				/>
			) : (
				<PlugTab />
			)}
			{isDeviationUser && isDeviationsTab && (
				<DeviationsTab
					permissions={props.permissions}
					path="deviations"
					label="tab.deviations.name"
				/>
			)}
			{isChatTab ? (
				<ChatTab
					isOSFCManager={isOSFCManager}
					permissions={props.permissions}
					label="tab.chat.name"
					path="chat"
				/>
			) : (
				<PlugTab />
			)}
			{isOrderHistoryTab ? (
				<OrderHistoryTab
					isOSFCManager={isOSFCManager}
					permissions={props.permissions}
					label="tab.order_history.name"
				/>
			) : (
				<PlugTab />
			)}
			<GeneralTab
				isOSFCManager={isOSFCManager}
				isCustomerAsTrans={isCustomerAsTrans}
				permissions={props.permissions}
				label="tab.order_general.name"
				path="general"
			/>
			{isOrderPrcelistHistoryTab ? (
				<OrderPrcelistHistoryTab
					isOSFCManager={isOSFCManager}
					permissions={props.permissions}
					label="tab.order_pricelist_history.name"
				/>
			) : (
				<PlugTab />
			)}
		</TabbedShowLayout>
	);
};

// export const OrderShowForTransporter = (props) => {
// 	return (
// 		<OrderShowTabsWrapper {...props} >
// 			<GeneralTab isPricelistNeed={false}/>
// 			<PlugTab/>
// 			<PlugTab/>
// 			<DocumentsTab/>
// 			<ChatTab/>
// 		</OrderShowTabsWrapper>
// 	);
// }

// export const OrderShowForCustomerTransporter = (props) => {
// 	return (
// 		<OrderShowTabsWrapper {...props} >
// 			<GeneralTab isPricelistNeed={null}/>
// 			<PlugTab/>
// 			<PlugTab/>
// 			<DocumentsTab/>
// 			<ChatTab/>
// 		</OrderShowTabsWrapper>
// 	);
// }
